import { Scalars }            from './graphql';
import { Uuid }               from './aliases';
import { ProjectDetailField } from '../constants/ProductEnums';
import { SemanticICONS }      from 'semantic-ui-react';
import { CorvalColor }        from './componentPropTypes';


export * from './router';

export interface CorvalAccountLike extends CorvalUserLike {
    id?: Scalars['Uuid'],
    emailAddress: string,
}

export interface CorvalUserLike {
    firstName: string
    lastName: string
}

/* An ID of an assumption or an enum of either a milestone or project field enum  */
export type AssumptionIdOrFieldName = Uuid | ProjectDetailField

/* Entity types for introspection, routing, etc. */
export enum ENTITY_TYPES {
    OBJECTIVE        = 'OBJECTIVE',
    OBJECTIVE_GROUP  = 'OBJECTIVE_GROUP',
    INTAKE_QUESTION  = 'INTAKE_QUESTION',
    ASSUMPTION       = 'ASSUMPTION',
    ACTIVITIES       = 'ACTIVITIES',
    CATEGORY         = 'CATEGORY',
    PROFESSIONAL_FEE = 'PROFESSIONAL_FEE',
    HIRE_TYPE        = 'HIRE_TYPE',
}

export interface IEntityIconDefintion {
    SYSTEM: {
        SETTINGS: SemanticICONS,
        SUPPORT: SemanticICONS,
    },
    QUESTIONS: {
        CORE: SemanticICONS,
        ADDITIVE: SemanticICONS,
        PROJECT: SemanticICONS,
    },
    DATA_VALUE_SETS: SemanticICONS,
    MILESTONES: {
        ENTITY: SemanticICONS,
        ITEM: SemanticICONS,
    },
    ASSUMPTIONS: {
        ENTITY: SemanticICONS,
        GROUPS: SemanticICONS,
    },
    OBJECTIVES: {
        GROUPS: SemanticICONS,
    },
    SUBOBJECTIVES: {
        ENTITY: SemanticICONS,
        VISUALIZATION: SemanticICONS,
        STATUS: SemanticICONS,
        STATUSES: {
            NOT_STARTED: SemanticICONS,
            IN_PROGRESS_LOW: SemanticICONS,
            IN_PROGRESS_MED: SemanticICONS,
            IN_PROGRESS_HIGH: SemanticICONS,
            COMPLETE: SemanticICONS,
        }
    },
    ACTIVITIES: {
        ENTITY: SemanticICONS,
        VISUALIZATION_GRID: SemanticICONS,
        VISUALIZATION_GANTT: SemanticICONS
        RECURRENCE: SemanticICONS,
        RISK_RATING: SemanticICONS,
        RISKS: {
            LATE_COMPLETION: SemanticICONS,
            AT_RISK: SemanticICONS,
            NONE: SemanticICONS,
        },
        STATUS: SemanticICONS,
        STATUSES: {
            NOTSTARTED: SemanticICONS,
            INCOMPLETE: SemanticICONS,
            COMPLETE: SemanticICONS,
            EXCLUDED: SemanticICONS,
        },
        CRITICALITY_RATING: SemanticICONS,
        TIMING: {
            EARLY: SemanticICONS,
            NORMAL: SemanticICONS,
            LATE: SemanticICONS,
        },
        CRITICALITY: {
            CRITICAL: SemanticICONS,
            PRIORITY: SemanticICONS,
            MODERATE: SemanticICONS,
            MINOR: SemanticICONS,
        }
    },
    USER: {
        ENTITY: SemanticICONS,
        WATCHER: SemanticICONS,
        RESOURCE: SemanticICONS,
        LOGOUT: SemanticICONS,
    },
    USER_ROLES: {
        SYSTEM: {
            CORVALADMIN: SemanticICONS,
            ACCOUNTSADMIN: SemanticICONS,
            DECISIONENGINEADMIN: SemanticICONS,
            MEMBER: SemanticICONS,
        },
        ORGANIZATIONAL: {
            ADMIN: SemanticICONS,
            MEMBER: SemanticICONS,
        },
        PROJECT: {
            ADMIN: SemanticICONS,
            MEMBER: SemanticICONS,
            VIEWER: SemanticICONS,
        }
    },
    PROJECTS: {
        ENTITY: SemanticICONS,
        SUBSCRIPTION_TYPES: {
            FREEUNLIMITED: SemanticICONS,
        },
        TEMPLATES: {
            ENTITY: SemanticICONS,
            TYPES: {
                FULLY_PACKAGED: SemanticICONS,
                GLOBALLY_FOCUSED: SemanticICONS,
                RESOURCE_FOCUSED: SemanticICONS,
                BUDGET_FOCUSED: SemanticICONS,
                TACTICAL: SemanticICONS,
                PRECISION: SemanticICONS,
                STRUCTURED: SemanticICONS,
                TIME_SENSITIVE: SemanticICONS,
                TARGETED: SemanticICONS,
                EXPERIMENTAL: SemanticICONS,
                LOCKED: SemanticICONS,
                DO_NOT_USE: SemanticICONS,
            }
        }
    },
    BUSINESS_FUNCTIONS: {
        ENTITY: SemanticICONS,
    },
    CATEGORIES: {
        ENTITY: SemanticICONS,
        GENERIC: SemanticICONS,
        INTERNAL: SemanticICONS,
        FIELD: SemanticICONS,
        OPERATIONS: SemanticICONS,
    },
    BUDGET: {
        REPORTING: SemanticICONS
        ENTITY: SemanticICONS,
        ENTITY_CATEGORICAL: SemanticICONS,
        ENTITY_HIRING: SemanticICONS,
        FEE_COSTS: SemanticICONS,
        OPERATIONAL_COSTS: SemanticICONS,
        SCHEDULED_COSTS: SemanticICONS,
        ONGOING_COSTS: SemanticICONS,
        HIRING_COSTS: SemanticICONS,
        RECURRENCE_COSTS: SemanticICONS,
        CUSTOM_DATA_CATEGORICAL: SemanticICONS,
        CUSTOM_DATA_HIRING: SemanticICONS,
        DATE_RANGE: SemanticICONS,
    },
    RESOURCING: {
        HIRES: {
            ENTITY: SemanticICONS,
        }
    },
    META: {
        TAG: SemanticICONS,
        LINKS: SemanticICONS,
    }
}

export interface IEntityColorDefintion {
    ACTIVITIES: {
        TIMING: {
            EARLY: CorvalColor,
            NORMAL: CorvalColor,
            LATE: CorvalColor,
        },
        CRITICALITY: {
            CRITICAL: CorvalColor,
            PRIORITY: CorvalColor,
            MODERATE: CorvalColor,
            MINOR: CorvalColor,
        },
        RISKS: {
            LATE_COMPLETION: CorvalColor,
            AT_RISK: CorvalColor,
            NONE: CorvalColor,
        }
    },
    CATEGORIES: {
        GENERIC: CorvalColor,
        INTERNAL: CorvalColor,
        FIELD: CorvalColor,
        OPERATIONS: CorvalColor,
    },
    MILESTONES: {
        DEFAULT: CorvalColor,
    }
}
